import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import WarningIcon from '@mui/icons-material/Warning';
import { Avatar, Button, Container, Typography } from '@mui/material';
import SimpleModal from '@/components/Modals/SimpleModal';

type ConfirmationModalProps = {
	open: boolean;
	title: string;
	text: string;
	okText?: string;
	okCallback?: () => void;
	cancelCallback?: () => void;
};

const ConfirmationModal: FC<ConfirmationModalProps> = ({
	open,
	title,
	text,
	okText,
	okCallback,
	cancelCallback,
}) => {
	const { t } = useTranslation();

	const content: React.ReactElement = (
		<Container component="main" maxWidth="xs">
			<div className="AuthModal__wrapper">
				<div className="AuthModal__title">
					<Avatar>
						<WarningIcon />
					</Avatar>
					<Typography
						component="h1"
						variant="h6"
						style={{ textAlign: 'center', marginTop: '10px' }}
					>
						{title}
					</Typography>
					<Typography
						component="p"
						variant="body1"
						sx={{ textAlign: 'center', marginTop: '10px' }}
					>
						{text}
					</Typography>
					<div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
						<Button variant="contained" color="primary" onClick={okCallback}>
							{okText || t('ok')}
						</Button>
						<Button variant="outlined" onClick={cancelCallback}>
							{t('cancel')}
						</Button>
					</div>
				</div>
			</div>
		</Container>
	);

	return (
		<div>
			<SimpleModal
				isOpen={open}
				handleClose={() => cancelCallback?.()}
				content={content}
				hideActions
			/>
		</div>
	);
};

export default ConfirmationModal;
